import React, { useState, useEffect } from 'react';
import { Modal, Button, FormCheck } from 'react-bootstrap';

import { three_decimals } from '../../helpers';
import { avgBlocksPerMonth } from './constants';

import success from './assets/success.png';
import './Modal.scss';

const blockpassUrl = "https://verify-with.blockpass.org/?clientId=open_campus_0027e&serviceName=OpenCampus&env=prod";

export function ConfirmStake({confirm, data, metadata, currEduPrice, ...props}) {
    const [optIn, setOptIn] = useState(true);
    const [est, setEst] = useState(0);

    const handleCheck = (e) => {
        setOptIn(e.target.checked)
    }

    useEffect(() => {
        if(data && metadata) {
            const total = data.reduce((acc, x) => {
                const { yieldPerBlock } = metadata[x];
                return acc + yieldPerBlock;
            }, 0);

            setEst(total * avgBlocksPerMonth);
        }
    }, [data, metadata])

    return (
        <Modal show={true} dialogClassName="custom-check" backdrop='static' centered>
            <Modal.Header>
                <div>
                    <h3>Confirm Your Stake</h3>
                    <p>You are about to stake the selected pNFTs. Confirm below to stake.</p>
                </div>
            </Modal.Header>
            <Modal.Body>
                {/* {console.log(data)} */}
                {/* {data.map((pnft, i) => (<div key={i}>{pnft}</div>))} */}
                {est 
                ? <>
                    <h4>{three_decimals.format(est)} EDU</h4>
                    <h5>(est. $US{three_decimals.format(est * currEduPrice)})</h5>
                    <p>Estimated Staking Reward per Month</p>
                </>
                : ''}

                <FormCheck
                    type="checkbox" 
                    aria-label="opt-in-check"
                    onChange={handleCheck} 
                    checked={optIn}
                    label={<>I agree to opt-in to TinyTap marketing fee. <a href="/Publisher_NFT_Staking_T&Cs.pdf" target='_blank'>Learn more</a></>}
                />
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => confirm(false)} variant='oc-secondary'>Cancel</Button>
                <Button onClick={() => confirm(true)} disabled={!optIn} variant='oc-primary'>Confirm Stake</Button>
            </Modal.Footer>
        </Modal>
    );
}


export function PendingPairGenesis({prom, ...props}) {
    const { data, title, btn } = props;

    const [pending, setPending] = useState(false);

    const handleClick = () => {
        setPending(true);
        prom()
            .then(_ => setPending(false))
            .catch(err => {
                setPending(false);
                console.error(err);
            });
    }

    return (
        <Modal show={true} dialogClassName="custom-check" backdrop='static' centered>
            <Modal.Header>
                <div>
                    <h3>{title}</h3>
                </div>
            </Modal.Header>
            <Modal.Body>
                <p>Total Genesis Tokens:</p>
                <p>Golden Backpack: {data[0]}</p>
                <p>Silver Notebook: {data[1]}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClick} variant='oc-primary' disabled={pending}>
                    {pending ? 'Please wait...' : btn}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function PendingStake({prom, ...props}) {
    const { data, title, btn } = props;

    const [pending, setPending] = useState(false);

    const handleClick = () => {
        setPending(true);
        prom()
            .then(_ => setPending(false))
            .catch(err => {
                setPending(false);
                console.error(err);
            });
    }

    return (
        <Modal show={true} dialogClassName="custom-check" backdrop='static' centered>
            <Modal.Header>
                <div>
                    <h3>{title}</h3>
                </div>
            </Modal.Header>
            <Modal.Body>
                Total pNFTs: {data}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClick} variant='oc-primary' disabled={pending}>
                    {pending ? 'Please wait...' : btn}
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export function ConfirmUnstake({confirm, data, ...props}) {
    return (
        <Modal show={true} dialogClassName="custom-check" backdrop='static' centered>
            <Modal.Header>
                <h3 id="confirm-pnft-stake">
                    Confirm Unstake
                </h3>
            </Modal.Header>
            <Modal.Body>
                <p>You are about to unstake the selected PNFTs. Confirm below to stake.</p>
                <p>Total pNFTs: {data.length}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => confirm(false)} variant='oc-secondary'>Cancel</Button>
                <Button onClick={() => confirm(true)} variant='oc-primary'>Confirm Unstake</Button>
            </Modal.Footer>
        </Modal>
    );
}

export function SwitchNetwork({prom, ...props}) {
    const { network = "BSC" } = props;

    return (
        <Modal show={true} dialogClassName="network-prompt" backdrop='static' centered>
            <Modal.Header>
                <Modal.Title id="switch-network">
                    Switch Network To {network}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>Please switch to the correct network to continue...</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={prom} variant='oc-primary'>Switch to {network}</Button>
            </Modal.Footer>
        </Modal>
    );
}

export function ConfirmKYC({confirm, ...props}) {
    return (
        <Modal show={true} dialogClassName="custom-check" backdrop='static' centered>
            <Modal.Header>
                <h3 id="confirm-kyc">
                    Warning: KYC is required to claim rewards
                </h3>
            </Modal.Header>
            <Modal.Body>
                <p>You have not yet passed the Open Campus KYC requirements. You must pass KYC in order to claim rewards.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => confirm(true)} variant='oc-secondary'>Skip for now</Button>
                <Button href={blockpassUrl} target='_blank' variant='oc-primary'>Start KYC Process</Button>
            </Modal.Footer>
        </Modal>
    );
}

export function SuccessModal({confirm, ...props}) {
    return (
        <Modal show={true} dialogClassName="oc-success" backdrop='static' centered>
            <Modal.Body>
                <h4>SUCCESS</h4>
                <p>{props.msg}</p>
                <img src={success} width={300} />
                <div className='ctrls'>
                    <Button variant="oc-secondary" onClick={() => confirm(true)}>Close</Button>
                    {props.next && <Button variant="oc-primary" onClick={() => {
                        props.next();
                        confirm(true);
                    }}>
                        Pair Genesis Now
                    </Button>}
                </div>
            </Modal.Body>
        </Modal>
    );
}



// function CustomSuccess({confirm, ...props}) {
//     const msg = {
//         "stake": 'Your LP has been staked',
//         "unstake": 'Your LP has been unstaked',
//         "claim": 'Your REDP has been claimed'
//     }

//     return (
//         <Modal show={true} dialogClassName="custom-success" backdrop='static' centered>
//             <Modal.Body>
//                 <div>
//                     <img src={require('../img/gamee/modal-success.png')} />
//                 </div>
//                 <h4>Success</h4>
//                 <p>{msg[props.type]}</p>
//                 <div className="btns-container">
//                     <Button variant="gamee" onClick={() => confirm(true)}>{t('Continue')}</Button>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// }

// function CustomError({confirm, ...props}) {
//     return (
//         <Modal show={true} dialogClassName="custom-error" backdrop='static' centered>
//             <Modal.Body>
//                 <div>
//                     <img src={require('../img/gamee/modal-error.png')} />
//                 </div>
//                 <h4>Oops</h4>
//                 <p>Sorry, something went wrong.</p>
//                 <div className="btns-container">
//                     <Button variant="gamee-error" onClick={() => confirm(true)}>Try Again</Button>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// }

function CustomCheck({confirm, ...props}) {
    const msg = {
        "stake": 'Are you sure you want to stake XXXX LP tokens?',
        "unstake": 'Are you sure you want to unstake all of your LP tokens?',
        "claim": 'Are you sure you want to claim your REDP?'
    }

    return (
        <Modal show={true} dialogClassName="custom-check" backdrop='static' centered>
            <Modal.Body>
                <h4>Confirm</h4>
                <p>{msg[props.type]}</p>
                <div className="btns-container">
                    <Button variant="dark" onClick={() => confirm(false)}>Cancel</Button>
                    <Button variant="gamee" onClick={() => confirm(true)} >Confirm</Button>
                </div>
            </Modal.Body>
        </Modal>
    );
}

// function PendingModal({prom, ...props}) {
//     const [t] = useTranslation();
//     const { type } = props;
//     const msgs = {
//         'stake': 'Staking... please wait',
//         'unstake': 'Unstaking... please wait',
//         'claim': 'Claiming... please wait'
//     }

//     useEffect(() => {
//         prom()
//     }, [])

//     return <Modal show={true} dialogClassName="pending-modal" backdrop='static' centered>
//         <Modal.Body>
//             <div className="pending-gif">
//                 <img src={require('../img/sand/loading.gif')} width={100} height={100} />
//             </div>
//             <h4>{t('Pending')}</h4>
//             <p>{t(msgs[type])}</p>
//         </Modal.Body>
//     </Modal>
// }

// function Pending(props) {
//     const { show, setShow } = props

//     return <Modal show={show} onHide={() => setShow(false)} dialogClassName="pending-modal" backdrop='static' centered>
//         <Modal.Body>
//             <div className="pending-gif">
//                 <img src={require('../img/gamee/loading.svg')} />
//             </div>
//             <p>Processing your transaction...</p>
//         </Modal.Body>
//     </Modal>
// }

// function SuccessModal(props) {
//     const { show, setShow } = props

//     return <Modal show={show} onHide={() => setShow(false)} dialogClassName="success-modal" centered>
//         <Modal.Body>
//             <div>
//                 <img src={require('../img/gamee/modal-success.png')} />
//             </div>
//             <h4>Success</h4>
//             <p>Your LP is successful.</p>
//             <div className="btns-container">
//                 <Button variant="gamee" onClick={() => setShow(false)}>Continue</Button>
//             </div>
//         </Modal.Body>
//     </Modal>
// }

// function ErrorModal(props) {
//     const { show, setShow } = props

//     return <Modal show={show} onHide={() => setShow(false)} dialogClassName="error-modal" centered>
//         <Modal.Body>
//             <div>
//                 <img src={require('../img/gamee/modal-error.png')} />
//             </div>
//             <h4>Error</h4>
//             <p>Oops. Something went wrong.</p>
//             <div className="btns-container">
//                 <Button variant="gamee" onClick={() => setShow(false)}>OK</Button>
//             </div>
//         </Modal.Body>
//     </Modal>
// }

// function ConfirmModal({confirm, ...props}) {
//     const {val} = props;

//     return (
//         <Modal show={true} dialogClassName="confirm-modal" centered>
//             <Modal.Body>
//                 <p>{`Your current approved amount is ${val}, do you want to stake this amount?`}</p>
//                 <div className="btns-container">
//                     <Button variant="gamee-light" onClick={() => confirm(false)}>Cancel</Button>
//                     <Button variant="gamee" onClick={() => confirm(true)} >Confirm</Button>
//                 </div>
//             </Modal.Body>
//         </Modal>
//     );
// }